// extracted by mini-css-extract-plugin
export default {"card":"ZZ-z","carouselContainer":"_Z-z","carouselContent":"a0-z"};